@if (!selectedStore && dataService.stores) {
  <div>
    @for (store of dataService.stores; track store) {
      <div class="col-lg-2 col-md-4 col-sm-6 float-start ps-4">
        <div class="store-card" (click)="navigateToStore(store)">
          <img src="../../assets/images/store-cards/store_{{store.slug}}_{{store.name | lowercase | removeWhiteSpace }}.jpg"
            (error)="$event.target.src = '../../assets/images/store-cards/store_not_found.jpg'"
            alt="{{store.name}}">
          <p class="store-card-name mt-2">{{ store.name }}</p>
        </div>
      </div>
    }
  </div>
}

<app-store-navigation></app-store-navigation>
@if ((hasAccessToViewPredictions() || hasAccessToViewRotas()) && selectedStore) {
  <div>
    <div class="alert alert-info" role="alert">
      Schedules will be updated overnight
    </div>
    @if (hasAccessToViewRotas() && rotaSummaries.length > 0) {
      <div class="pb-2">
        <a routerLink="/export-rotas" class="btn btn-primary-outline">Export rotas to PDF</a>
      </div>
    }
    <div class="shadow-sm bg-light rounded">
      <table class="table table-hover">
        <thead>
          <tr>
            <th scope="col" class="border-top-0 week-number-title">Week</th>
            <th scope="col" class="border-top-0 week-from-title">From</th>
            <th scope="col" class="border-top-0 week-to-title">To</th>
            <th scope="col" class="border-top-0"></th>
            <th scope="col" class="border-top-0">
              @if (requestsAreLoading()) {
                <span class="fw-normal ms-3">
                  <span class="spinner-border spinner-border-sm me-1"></span> Loading...
                </span>
              }
            </th>
          </tr>
        </thead>
        <tbody>
          @for (week of predictionRotaWeeks; track week) {
            <tr>
              <th scope="row" class="week-number">{{week.from | dateParse | dateFormat:'WW'}}</th>
              <td class="week-from">{{ week.from | dateParse | dateFormat: 'ddd, D MMM YYYY' }}</td>
              <td class="week-to">{{ week.to | dateParse | dateFormat: 'ddd, D MMM YYYY' }}</td>
              <td></td>
              <td class="week-actions">
                @if (hasAccessToViewPredictions()) {
                  <button
                    routerLink="/footfall-week/{{week.id}}"
                    [ngClass]="{'link-disabled': week.dailyPredictions.length === 0 || requestsAreLoading()}"
                  class="btn btn-primary-outline btn-sm">Predictions</button>
                }
                @if (hasAccessToViewRotas()) {
                  <button
                    routerLink="/rota-week/{{week.id}}"
                    [ngClass]="{'link-disabled': !week.rotaExist || requestsAreLoading()}"
                  class="btn btn-primary btn-sm ms-2">Rota</button>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
}
